import * as React from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Typography,
  FormLabel,
  useTheme,
} from "@mui/material";

type Option = {
  label: string;
  value: string;
  disabled?: boolean;
};

type Props = {
  fieldLabel?: string;
  size?: "small" | "medium";
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  name?: string;
  orientation?: "horizontal" | "vertical";
  labelPosition?: "start" | "end";
};



const RadioButtonIcon = ({ checked, size = 'small' }: { checked?: boolean; size?: 'small' | 'medium' }) => {
  const theme = useTheme();
  const colors = theme.palette;
  const outerSize = size === 'small' ? 18 : 24;
  const innerSize = size === 'small' ? 16 : 22;

  return (
    <div
      style={{
        width: outerSize,
        height: outerSize,
        borderRadius: "50%",
        border: `2px solid ${checked ? colors.radioGroup.radioCheckedBackground : colors.radioGroup.radioBorder }`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {checked && (
        <div
          style={{
            width: innerSize,
            height: innerSize,
            borderRadius: "50%",
            backgroundColor: colors.radioGroup.radioCheckedBackground,
          }}
        />
      )}
    </div>
  );
};

export const RadioButtons: React.FC<Props> = ({
  fieldLabel,
  size = 'small',
  options,
  value,
  onChange,
  name = "mui-radio-group",
  orientation = "horizontal",
  labelPosition = "end"
}) => {
  const isRow = orientation === "horizontal";

  return (
    <FormControl>
      {fieldLabel && <FormLabel id="demo-radio-buttons-group-label" sx={{ mb: 1 }}>{fieldLabel}</FormLabel>}
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        row={isRow}
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          gap: isRow ? 4 : 1.5,
          maxWidth: 'fit-content'
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                disableRipple
                icon={<RadioButtonIcon size={size} />}
                checkedIcon={<RadioButtonIcon checked size={size} />}
                sx={{
                  padding: "4px",
                  "& .MuiSvgIcon-root": {
                    display: "none",
                  },
                }}
              />
            }
            label={<Typography variant="bodyLabel" sx={{ color: '#000000' }}>{option.label}</Typography>}
            disabled={option.disabled}
            labelPlacement={labelPosition}
            sx={{
              margin: 0,
              gap: "6px",
              marginRight: isRow ? 4 : 0,
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
